import pinConversations from './pinConversations';
import pinItems from './pinItems';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Toggle the row pinned status
 * @param rowKey row key to pin/unpin
 * @param tableViewId of the table that the row belong to
 * @param actionSource the action source
 */
export default function toggleRowPinnedState(
    rowKey: string,
    tableViewId: string,
    actionSource: ActionSource
) {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const isRowPinned = MailRowDataPropertyGetter.getIsPinned(rowKey, tableView);

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            pinConversations([rowKey], tableView, !isRowPinned, actionSource);
            break;

        case ReactListViewType.Message:
            pinItems([rowKey], tableView, !isRowPinned, actionSource);
            break;
    }
}
